/*
 * @Author: ailin
 * @Date: 2022-07-20 10:40:41
 * @LastEditors: ailin
 * @LastEditTime: 2022-07-20 10:42:50
 * @Description: file content
 * @FilePath: /broadcast/src/assets/js/utils.ts
 */
// 防抖(ts)
export class Debounced {
    /**
     * @param func 需要包装的函数
     * @param delay 延迟时间，单位ms
     * @param immediate 是否默认执行一次(第一次不延迟)
     */
    public use = (func: Function, delay: number, immediate: boolean = false): Function => {
      let timer: number | undefined
      return ( ...args: any) => {
        if (immediate) {
          func.apply(this, args) // 确保引用函数的指向正确，并且函数的参数也不变
          immediate = false
          return
        }
        clearTimeout(timer)
        timer = setTimeout(() => {
          func.apply(this, args)
        }, delay)
      }
    }
  }
  
  // 节流(ts)
  export class Throttle {
    private timer: number | undefined
    private stop: boolean = false
    private death: boolean = false
    /**
     * @param func 需要包装的函数
     * @param delay 延迟时间，单位ms
     * @param immediate 是否默认执行一次(第一次不延迟)
     */
    public use (func: Function, delay: number, immediate: boolean = false): Function {
      let flag = true
      const self = this
      return (...args: any) => {
        if (this.death) {
          func.apply(this, args)
          return
        }
        if (this.stop) {
          func.apply(this, args)
          return
        }
        if (immediate) {
          func.apply(this, args)
          immediate = false
          return
        }
        if (!flag) {
          return
        }
        flag = false
        self.timer = setTimeout(() => {
          func.apply(this, args)
          flag = true
        }, delay)
      }
    }
  
    // 销毁
    public destroy() {
      this.death = true
      this.stop = true
      if (!!this.timer) {
        clearTimeout(this.timer)
        this.timer = undefined
      }
    }
    // 开启
    public open() {
      if (!this.death) {
        this.stop = false
      }
    }
    // 关闭
    public close() {
      this.stop = true
    }
  }
  /**
 * 精确计算两个日期的天数差（包含时分秒，可能返回小数）
 * @param {String | Date} date1 日期1
 * @param {String | Date} date2 日期2
 * @returns {Number | null} 精确天数差
 */
export const getPreciseDayInterval=(date1:any, date2:any)=>{
  console.log(date1,date2)
  const d1 = typeof date1 === 'string' ? new Date(date1) : date1;
  const d2 = typeof date2 === 'string' ? new Date(date2) : date2;

  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    console.error('无效日期');
    return null;
  }

  const timeDiff = Math.abs(d1.getTime() - d2.getTime());
  return timeDiff / 86400000; // 不取整，保留小数
}  